import React, { ChangeEvent, DragEvent, ReactChild, RefObject, useState } from "react"
import styled from "styled-components"

interface Props {
  isConfirm?: boolean
  accept?: string
  value?: number
  onSuccess?: (value: any) => void
  children?: ReactChild | ReactChild[]
}
export default function AcUploader(props: Props) {
  const { value, isConfirm = false, accept = "*.*", onSuccess, children } = props

  const [isDrag, setIsDrag] = useState(false)
  const onFileBrowser = () => {
    if (!isConfirm) {
      file.current?.click()
    }
  }
  const file: RefObject<HTMLInputElement> = React.createRef()

  const onDrop = (event: DragEvent<HTMLDivElement>) => {
    if (!isConfirm) {
      setIsDrag(false)
      event.preventDefault()
      if (!event) {
        return
      }
      if (!event.dataTransfer) {
        return
      }
      if (event.dataTransfer.files.length === 0) {
        return
      }
      const fileList = event.dataTransfer.files
      if (fileList.length > 0) {
        if (accept === "*.*" || accept === fileList[0].type || accept === ".csv") {
          onSuccess(fileList)
        }
      }
    }
  }

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files.length > 0) onSuccess(e.target.files)
  }

  return (
    <>
      <Content>
        <div
          className={`${isDrag ? "draggable" : ""}`}
          onClick={onFileBrowser}
          onDragOver={(event) => {
            if (!isConfirm) {
              event.preventDefault()
              setIsDrag(true)
              return false
            }
          }}
          onDragLeave={(event) => {
            if (!isConfirm) {
              event.preventDefault()
              setIsDrag(false)
              return false
            }
          }}
          onDrop={onDrop}
        >
          {children}
          <input
            ref={file}
            type="file"
            style={{ display: "none" }}
            accept={accept}
            onChange={onChange}
          />
        </div>
      </Content>
    </>
  )
}
const Content = styled.div`
  .form-label {
    margin-bottom: 0px;
  }
`
